const HOME = '/';
const ABOUT = '/about';
const WORK = '/#my-work';

export const ROUTE = {
  HOME,
  ABOUT,
  WORK,
};
